export const getPageList = ({
  maxPages = 1,
  currentPage = 1,
  maxDifference = 3,
  showEllipsis = false,
}) => {
  //
  if (1 > currentPage || currentPage > maxPages)
    throw new Error("Invalid page");
  const range = (start, end) =>
    Array.from({ length: end - start + 1 }, (_, i) => start + i);
  let pages = [];
  // Always start with the first page.
  pages.push(1);
  // If there's a gap between the first page and the current page, add an ellipsis.
  if (showEllipsis && currentPage - maxDifference > 2) pages.push("...");
  // Add the range of pages around the current page.
  const startRange = Math.max(currentPage - maxDifference, 2);
  const endRange = Math.min(currentPage + maxDifference, maxPages - 1);
  pages.push(...range(startRange, endRange));
  // If there's a gap between the current page range and the last page, add an ellipsis.
  if (showEllipsis && currentPage + maxDifference < maxPages - 1)
    pages.push("...");
  // Always end with the last page.
  pages.push(maxPages);
  return pages;
};
